/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';

import { P } from '../P/P';

export const UL = styled(P)`

  list-style-type: ${({ disc, square }) => (disc ? 'circle' : (square ? 'square' : 'disc'))};

  padding-left: 20px;

`.withComponent('ul');



// WEBPACK FOOTER //
// ./src/components/LE/UL.js